'use strict';
var React = require('react');
var Border = require('../common/Border');
var LabelParts = require('../common/LabelParts');
var textHelper = require('../../helper/util').Text;
var styleHelper = require('../../helper/styleHelper');

/**
 * 分段控件
 */
var ScopeBar = React.createClass({

  getInitialState: function () {
    return {selectedIndex: this.props.selectedIndex}
  },
  render: function () {
    var textItems = textHelper.delimitText(styleHelper.getText(this.props),textHelper.DM_COMMA);
    var length = textItems.length;
    var itemW = (this.props.w - 2) / length;
    this.itemCount = length;
    var borderStyle = {
      borderWidth: 1,
      borderRadius: styleHelper.getRadius(this.props),
      overflow: 'hidden'
    };

    return (<Border {...this.props} partStyle={borderStyle}>

      {
        textItems.map(function (text, index) {
          return (<div
            key={index}
            onClick={this.onItemClick.bind(this, null, index)}
            onMouseOver={this.onItemMouseOver.bind(this, index)}
            onMouseOut={this.onItemMouseOut}
            style={{
              left: itemW * index,
              width: (index === length - 1) ? (this.props.w - index * itemW ) : itemW,
              height: this.props.h - 2,
              position: 'absolute',
              overflow:'hidden',
              backgroundColor: (index === this.state.selectedIndex) ? this.props.selectedColor : (this.props.showHover && index === this.state.hoverIndex ? this.props.hoveredColor : null)
            }}>

            <LabelParts {...this.props} text={text} partStyle={{
              width: itemW,
              height: this.props.h - 2,
              lineHeight: (this.props.h - 2) + 'px',
              textAlign: 'center',
              position: 'absolute',
              color : index === this.state.selectedIndex?styleHelper.getSelectedTextColor(this.props):styleHelper.getTextColor(this.props)
            }}/>
          </div>);
        }, this)
      }
    </Border>)
  },

  onItemClick: function (e, i) {
    this.setState({selectedIndex: i});
  },

  onItemMouseOver: function (index) {
    if (this.props.showHover) {
      this.setState({hoverIndex: index});
    }
  },

  onItemMouseOut: function () {
    this.setState({hoverIndex: -1});
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this))
      .bind('itemClick', this.onItemClick);
  }

});

module.exports = ScopeBar;



/** WEBPACK FOOTER **
 ** ./src/views/Components/ScopeBar.jsx
 **/